module.exports = __webpack_public_path__ + "a939f96699c990bff5e12fac3cd1936b.pdf";